export default __webpack_public_path__ + "static/media/moneyimage.833e6135.svg";